/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

export default class ClassicEditor extends ClassicEditorBase {
}

import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Clipboard from '@ckeditor/ckeditor5-clipboard/src/clipboard';
import Enter from '@ckeditor/ckeditor5-enter/src/enter';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import ShiftEnter from '@ckeditor/ckeditor5-enter/src/shiftenter';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties';
import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import Typing from '@ckeditor/ckeditor5-typing/src/typing';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import Undo from '@ckeditor/ckeditor5-undo/src/undo';

ClassicEditor.builtinPlugins = [
	Alignment,
	Autoformat,
	BlockQuote,
	Bold,
	Clipboard,
	Enter,
	Heading,
	Italic,
	Link,
	List,
	MediaEmbed,
	Paragraph,
	ShiftEnter,
	SourceEditing,
	Table,
	TableCellProperties,
	TableProperties,
	TableToolbar,
	Typing,
	Underline,
	Undo
];

ClassicEditor.defaultConfig = {
	toolbar: {
		items: [
			'heading',
			'|',
			'undo',
			'redo',
			'|',
			'bold',
			'italic',
			'underline',
			'link',
			'mediaEmbed',
			'|',
			'alignment:left',
			'alignment:center',
			'alignment:right',
			'alignment:justify',
			'|',
			'bulletedList',
			'numberedList',
			'blockQuote',
			'insertTable',
			'|',
			'sourceEditing'
		]
	},
	heading: {
		options: [
			{ model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
			{ model: 'heading1', view: 'h1', title: 'Heading 1', class: 'heading--1' },
			{ model: 'heading2', view: 'h2', title: 'Heading 2', class: 'heading--2' },
			{ model: 'heading3', view: 'h3', title: 'Heading 3', class: 'heading--3' },
			{ model: 'heading4', view: 'h4', title: 'Heading 4', class: 'heading--4' },
			{ model: 'heading5', view: 'h5', title: 'Heading 5', class: 'heading--5' },
			{ model: 'heading6', view: 'h6', title: 'Heading 6', class: 'heading--6' }
		]
	},
	table: {
		contentToolbar: [
			'tableColumn',
			'tableRow',
			'mergeTableCells',
			'tableProperties',
			'tableCellProperties'
		]
	},
	alignment: {
		options: [ 'left', 'right', 'center', 'justify' ]
	},
	language: 'en'
};
